import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const widgetCardStyle = {
  p: 3,
  borderRadius: 3,
  border: '1px solid',
  borderColor: 'divider',
  height: 'fit-content',
};

/**
 * A consistent widget card with optional icon + title bar.
 * Used for Profile and Skaters page sections.
 */
export default function WidgetCard({ title, icon, children, sx = {} }) {
  return (
    <Paper elevation={0} sx={{ ...widgetCardStyle, ...sx }}>
      {(title || icon) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
          }}
        >
          {icon && (
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
              }}
            >
              {icon}
            </Box>
          )}
          {title && (
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
          )}
        </Box>
      )}
      {children}
    </Paper>
  );
}
